export default "__VITE_ASSET__BiebUDd2__";